module.exports = __webpack_public_path__ + "img/headTopLogo.c30452fa.png";